import React, { Component } from 'react';
import Button from '../../Button';
import apiInstance from '../../apiInstance';

class DeletePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: props.data?.userId || '',
            availableWidgetId: props.data?.availableWidgetId || '',
            widgetId: props.data?.widgetId || '',
            paymentId: props.data?.paymentId || '',
            type: props?.type || 'user',
            closeUserDetail:    props.data?.closeUserDetail,
        };
    }

    delete = () => {
        let {type} = this.state;

        if(type === 'user') {
            
            const { userId } = this.state;
            apiInstance.delete(`/devadmin/user/${userId}`)
                .then(response => {
                    this.props.deleteUser(userId)
                    this.props.closePopup();
                    if(this.state.closeUserDetail){
                        this.state.closeUserDetail();
                    }
                })
                .catch(error => {
                    console.error('Error deleting the user:', error);
                    this.props.updateError(error.response.data)
                });
        } else if(type === 'availableWidget') {
            const { availableWidgetId } = this.state;
            apiInstance.delete(`/devadmin/availableWidget/${availableWidgetId}`)
                .then(response => {
                    this.props.deleteAvailableWidget(availableWidgetId)
                    this.props.closePopup();
                })
                .catch(error => {
                    console.error('Error deleting the widget:', error);
                    this.props.updateError(error.response.data)
                });
        } else if(type === 'widget') {
            const { widgetId } = this.state;
            apiInstance.delete(`/devadmin/widget/${widgetId}`)
                .then(response => {
                    this.props.deleteWidget(widgetId)
                    this.props.closePopup();
                })
                .catch(error => {
                    console.error('Error deleting the widget:', error);
                    this.props.updateError(error.response.data)
                });
        } else  if(type === 'payment') {
            
            const { paymentId } = this.state;
            apiInstance.delete(`/devadmin/payment/${paymentId}`)
                .then(response => {
                    this.props.deletePayment(paymentId)
                    this.props.closePopup();
                })
                .catch(error => {
                    console.error('Error deleting the payment:', error);
                    this.props.updateError(error.response.data)
                });
        } 
    }

    render () {

        let deleteText = '';
        switch(this.state.type) {
            case 'user': deleteText = 'user'; break;
            case 'availableWidget': deleteText = 'product'; break;
            case 'widget': deleteText = 'widget'; break;
            case 'payment': deleteText = 'payment'; break;
            default: deleteText = '';
        }

        return (
            
                <div className='mjwidev-delete-user-pp mjwidev-pp'>
                    <h2>DELETE</h2>
                    <p>Do you really want to delete this {deleteText}?</p>
                    <div class="mjwidev-bottom-row">
                        <Button name="Delete" eventHandler={() => {this.delete()}} />
                    </div>
                </div>
            
        );
    }
}

export default DeletePopup;
  